import { render, staticRenderFns } from "./HelpPageFormModal.vue?vue&type=template&id=5b560969&scoped=true"
import script from "./HelpPageFormModal.vue?vue&type=script&lang=js"
export * from "./HelpPageFormModal.vue?vue&type=script&lang=js"
import style0 from "./HelpPageFormModal.vue?vue&type=style&index=0&id=5b560969&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b560969",
  null
  
)

export default component.exports